import { Typography } from '@mui/material';

interface TitleProps {
  node: any;
}

export function Title({ node }: TitleProps) {
  const styles = node.data.styles;

  return (
    <Typography
      variant="h6"
      style={{
        fontFamily: styles?.title?.fontFamily || 'Roboto, sans-serif',
        fontWeight: styles?.title?.isBold ? '700' : '400',
        fontStyle: styles?.title?.isItalic ? 'italic' : 'normal',
        textDecoration: styles?.title?.isUnderlined ? 'underline' : 'none',
        textAlign: styles?.title?.textAlign || 'center',
        fontSize: `${styles?.title?.fontSize || 16}px`,
        color: styles?.title?.color || '#1F2937',
        width: '100%',
        lineHeight: '150%',
        letterSpacing: '0.5px',
      }}
    >
      {node.data.title}
    </Typography>
  );
}
